// ───────────────────────────────────────────────────────────────
// Site content
// ───────────────────────────────────────────────────────────────

export const NAME = "Alex Lama-Noujaim";
export const ROLE = "Design Systems";

// Two lines, no more. The first says what, the second says where from.
// Strings are plain text; objects are links.
const anthropic = { text: "Anthropic", href: "https://www.anthropic.com" };
const airtable = { text: "Airtable", href: "https://www.airtable.com" };
const tray = { text: "Tray.io", href: "https://tray.ai" };
export const INTRO = [
  ["Design systems at ", anthropic, "."],
  ["Previously ", airtable, " and ", tray, ". London."],
];

export const EMAIL = "lamanoujaim@gmail.com";
export const LINKEDIN = "https://linkedin.com/in/lamanoujaim";

// Selected work — a short, curated list. Everything is black and white
// until hovered; `color` is the one color that project is allowed
// (sampled from its media), shown in the mark and the row's index.
//   media   file in public/assets/work/ — shown as a dither-developed preview
//   ratio   media aspect ratio, reserved before it loads
//   route   optional [lat, lon] stops — while hovered, the mark becomes a
//           globe and this route draws across it
export const WORK = [
  { title: "Design system", org: "Anthropic", year: "2026", media: "/assets/work/design-system.mp4", ratio: 16 / 9, color: "#c46a4a" },
  { title: "Desktop app", org: "Anthropic", year: "2026", media: "/assets/work/desktop.mp4", ratio: 16 / 9, color: "#4f9c86" },
  { title: "Widgets", org: "Anthropic", year: "2026", media: "/assets/work/widgets-short.mp4", ratio: 16 / 10, color: "#4d7aa3" },
  { title: "Apps", org: "Airtable", year: "2024", media: "/assets/work/apps.mp4", ratio: 16 / 9, color: "#3c9ccc" },
  { title: "Timeline", org: "Airtable", year: "2023", media: "/assets/work/timeline-loop.mp4", ratio: 16 / 9, color: "#a442a4" },
  { title: "Workflow automations", org: "Tray.io", year: "2021", media: "/assets/work/workflow-night.mp4", ratio: 16 / 9, color: "#4a78d6" },
  { title: "Cycle to Lebanon", org: "Sabbatical", year: "2019", media: "/assets/work/cycling.mp4", ratio: 16 / 9, color: "#d9a441",
    // London, Paris, Munich, Vienna, Belgrade, Istanbul, Antakya, Beirut
    route: [[51.51, -0.13], [48.86, 2.35], [48.14, 11.58], [48.21, 16.37], [44.79, 20.45], [41.01, 28.98], [36.2, 36.16], [33.89, 35.5]] },
  { title: "Agent-based modelling", org: "Simudyne", year: "2017", media: "/assets/work/simudyne.mp4", ratio: 16 / 9, color: "#b56be6" },
];
